import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.css']
})
export class CardComponent implements OnInit {

  @Input() thumbNail: any;
  @Input() title: string;
  @Input() description: string;
  @Input() number: string;
  @Input() addDate: string;

  constructor() {
    this.title = "testing title";
    this.description = "dummy description";
    this.number = "test number"
    this.addDate = new Date().getDate() + "/" + new Date().getMonth() + "/" + new Date().getFullYear();
  }

  ngOnInit(): void {

  }

  clickHandler() {
    console.log("clicked");
  }
}

